import React from "react";
import EarthIcon from "../icons/EarthIcon";
import LockIcon from "../icons/LockIcon";

type VisibilityIndicatorProps = {
  fontSize: number;
  visibility: "public" | "private";
};

export const VisibilityIndicator: React.FC<VisibilityIndicatorProps> = ({
  fontSize,
  visibility,
}) => {
  const isPublic = visibility === "public";
  const color = isPublic ? "#0FAC33" : "#000";

  return (
    <div className="visibility-indicator">
      {isPublic ? <EarthIcon /> : <LockIcon />}
      <span>{isPublic ? "Public" : "Private"}</span>
      <style jsx>{`
        .visibility-indicator {
          display: flex;
          align-items: center;
          color: ${color};
          font-size: ${fontSize}px;
          font-weight: 600;
        }

        .visibility-indicator :global(svg) {
          margin-right: ${fontSize / 6}px;
          height: ${fontSize * 1.5}px;
          width: ${fontSize * 1.5}px;
          fill: ${color};
        }

        .visibility-indicator :global(svg path) {
          fill: ${color};
        }
      `}</style>
    </div>
  );
};

export default VisibilityIndicator;
